import React from 'react';
import ModalButtons from "../ModalButtons/ModalButtons";
import DateHelper from "../DateHelper/DateHelper";
import { parseISO, format } from "date-fns";

export default class RuQueueLogPresenter extends React.Component {
  constructor(props) {
    super(props)
    // this.state = {
    //   queued_at: this.props.queued_at ? parseISO(this.props.queued_at) : null,
    //   completed_at: this.props.completed_at ? parseISO(this.props.completed_at) : null,

    // }
  }

  render() {
    return (
      <div className="queue-log-presenter">
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('queued_at')}*`}</label>
              {/* <div>{format(parseISO(this.props.queued_at), DateHelper.rubyToDateFNS(this.props.date_format))}</div> */}
              <div>{DateHelper.printDateToScreen(this.props.queued_at, this.props.date_format)}</div>

            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('completed_at')}*`}</label>
              {/* <div>{format(parseISO(this.props.completed_at), DateHelper.rubyToDateFNS(this.props.date_format))}</div> */}
              <div>{DateHelper.printDateToScreen(this.props.completed_at, this.props.date_format)}</div>

            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('status')}*`}</label>
              <div>{this.props.status}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('record_type')}*`}</label>
              <div>{this.props.queueable_type}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('rentals_united_response')}*`}</label>
              <div>{this.props.rentals_united_response_status ? this.props.rentals_united_response_status.description : null}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('error_message')}*`}</label>
              <div>{this.props.error_message}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('record_id')}*`}</label>
              <div>{this.props.queueable_id}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('call_payload')}`}</label>
              <div>{this.props.call_payload}</div>
            </div>
          </div>
        </div>
      </div>

    )
  }


}
